import { AppCacheService } from '../cache/app-cache.service';
import { CacheName } from '../../constants/cache.constants';
import { CacheConstant } from '../../constants/app.constant';

export class StaticBase {
  constructor(private selector: string, private cache: AppCacheService) {}

  protected getData(): Array<any> {
    const data = this.cache.get(CacheConstant.Static_Data);
    let itemData: any = null;

    if (data) {
      itemData = data[this.selector];
    }

    return itemData;
  }

  protected setItem(propertyName: string, propertyValue: any, object: any) {
    const data = this.getData();

    if (data) {
      const objectIndex = data.findIndex(
        item => item[propertyName] === propertyValue
      );

      if (objectIndex === -1) {
        data.push(object);
      } else {
        data[objectIndex] = object;
      }

      const staticdata = this.cache.get(CacheConstant.Static_Data);
      staticdata[this.selector] = data;
      this.cache.set(CacheConstant.Static_Data, staticdata, Number.MAX_VALUE);
    }
  }

  protected getItem(propertyName: string, propertyValue: any): any {
    let value: any = null;
    const data = this.getData();

    if (data) {
      const filteredData = data.filter(
        item => item[propertyName] === propertyValue
      );

      value = filteredData && filteredData.length > 0 ? filteredData[0] : value;
    }

    return value;
  }
}
